import cx from 'classnames';
import React, { FC } from 'react';

import useThemeBlock from '@/hooks/useThemeBlock';
import { CardShow } from '@/components/molecules/CardShow/render';
import { getStyles } from './styles.css';

import block from './block.json';

/**
 * TYPINGS
 */
export type ListEventsProps = ThemeProps & {
	events?: Array<CardShowProps>;
};

/**
 * COMPONENT
 */
export const ListEvents: FC<ListEventsProps> & BlockConfigs = ({
	events,
	theme = {},
}) => {
	const { variant, blockTheme } = useThemeBlock(block.slug, theme);

	const rootClass = cx(
		'supt-listCards supt-listEvents',
		getStyles(blockTheme)
	);

	return (
		<div
			className={rootClass}
			data-block={block.slug}
			data-variant={variant}
		>
			{events?.map((event, index) => (
				<CardShow
					key={index}
					{...event}
					variants={['highlighted', 'light']}
				/>
			))}
		</div>
	);
};

ListEvents.slug = block.slug;
ListEvents.title = block.title;
